import React from "react";
import { Flex, Text } from "@chakra-ui/react";
import CustomApprovalModal from "@/shared/components/custom-modal";
import AppButton from "@/features/line-sheet-sets/app-button";
import CustomIcon from "../../../../../public/icons-v1_1";
import useI18nHelper from "@/features/ui/hooks/use-i18n-helper";

interface Props {
  isOpen: boolean;
  onClose: () => void;
  // 선택한 상품 수 — 버튼 라벨과 안내 문구에 함께 들어간다.
  count: number;
  isLoading: boolean;
  onUnsyncOnly: () => void;
  onDelete: () => void;
}

// 선택 상품 연동 해제 확인 — 연동만 해제 / 상품까지 삭제 중 하나를 고른다.
// 실제 mutation은 부모(각 목록 모달)가 소유한다.
function PathPickUnsyncConfirmModal({
  isOpen,
  onClose,
  count,
  isLoading,
  onUnsyncOnly,
  onDelete,
}: Props) {
  const { t } = useI18nHelper();

  return (
    <CustomApprovalModal
      isOpen={isOpen}
      onClose={onClose}
      minWidth={"min(520px, 90dvw)"}
      isCentered={true}
    >
      <CustomApprovalModal.Header
        onClose={onClose}
        title={t("path_pick:sync_download_history.unsync_confirm.title")}
      />
      <CustomApprovalModal.Body>
        <Flex flexDirection={"column"} gap={"12px"}>
          <Text textStyle={"body-md-bold"} color={"#1D1D1B"}>
            {t("path_pick:sync_download_history.unsync_confirm.body", {
              count,
            })}
          </Text>
          <Text textStyle={"body-sm-medium"} color={"#444440"}>
            {t("path_pick:sync_download_history.unsync_confirm.description")}
          </Text>

          {/* 액션이 3개(취소/연동 해제/상품 삭제)라 공용 Footer 대신 자체 푸터로 처리 */}
          <Flex justifyContent={"flex-end"} gap={"8px"}>
            <AppButton variant={"white"} onClick={onClose}>
              <Text textStyle={"body-sm-bold"}>
                {t("path_pick:sync_download_history.unsync_confirm.cancel")}
              </Text>
            </AppButton>
            <AppButton
              variant={"white"}
              isLoading={isLoading}
              onClick={onUnsyncOnly}
            >
              <Flex gap={"4px"} alignItems={"center"}>
                <CustomIcon
                  src={"x-circle"}
                  width={16}
                  height={16}
                  color={"#EE7D7A"}
                />
                <Text textStyle={"body-sm-bold"} color={"#EE7D7A"}>
                  {t(
                    "path_pick:sync_download_history.unsync_confirm.confirm_unsync",
                    { count }
                  )}
                </Text>
              </Flex>
            </AppButton>
            <AppButton
              variant={"white"}
              isLoading={isLoading}
              onClick={onDelete}
            >
              <Flex gap={"4px"} alignItems={"center"}>
                <CustomIcon
                  src={"trash"}
                  width={16}
                  height={16}
                  color={"#EE7D7A"}
                />
                <Text textStyle={"body-sm-bold"} color={"#EE7D7A"}>
                  {t(
                    "path_pick:sync_download_history.unsync_confirm.confirm_delete",
                    { count }
                  )}
                </Text>
              </Flex>
            </AppButton>
          </Flex>
        </Flex>
      </CustomApprovalModal.Body>
    </CustomApprovalModal>
  );
}

export default PathPickUnsyncConfirmModal;
